import { FaCircleArrowUp, FaCircleArrowDown } from "react-icons/fa6";
import { useContext, useEffect, useState, useCallback } from "react";
import SocketContext from "../../../../../context/SocketContext";

export default function ProfitLoss({ symbol_id, item }) {
  const socket = useContext(SocketContext);
  const [profit, setProfit] = useState(0);

  // 🧩 Memoized trade handler
  const handleTrade = useCallback(
    (data) => {
      if (!data || !item) return;

      const rate = Number(item.rate) || 0;
      const qty = Number(item.qty) || 0;
      // const dollarRate = Number(item.dollar_rate) || 1;

      let price = 0;
      const bid = Number(data.Bid) || 0;
      const ask = Number(data.Ask) || 0;
      const ltp = Number(data.LTP) || 0;

      // Determine latest valid price
      if (item.buy_sell === 0) price = bid > 0 ? bid : ltp;
      else price = ask > 0 ? ask : ltp;

      let pf =
        item.buy_sell === 0
          ? (price - rate) * qty // Buy
          : (rate - price) * qty; // Sell

      // Apply dollar conversion
      // if (
      //   ["comex_future", "crypto_future", "forex_future"].includes(item.type)
      // ) {
      //   pf *= dollarRate;
      // }

      setProfit(pf);
    },
    [item]
  );

  // 🧠 Socket subscription
  useEffect(() => {
    if (!socket || !symbol_id) return;

    const event = "trade" + symbol_id;
    socket.emit("giverate", symbol_id);
    socket.on(event, handleTrade);

    return () => {
      socket.off(event, handleTrade);
    };
  }, [socket, symbol_id, handleTrade]);

  const isProfit = profit > 0;
  const colorClass = isProfit ? "buytext" : "selltext";

  return (
    <div className="menuIcon" title={`P/L: ${profit.toFixed(2)}`}>
      {isProfit ? (
        <FaCircleArrowUp size={18} className={colorClass} />
      ) : (
        <FaCircleArrowDown size={18} className={colorClass} />
      )}
    </div>
  );
}
